export enum FileType {
  json = 'json',
  csv = 'CSV',
}

export enum FileTypeE {
  csv,
  json,
}

export enum FinancialReportType {
  tasks = 'zadania',
  RGZ = 'RGZ',
}

export enum FinancialReportE {
  tasks,
  RGZ,
}

export enum ExaminerIdType {
  pesel = 'pesel',
  schoolId = 'schoolId',
}

export enum BackendErrorCode {
  InvalidExamineeIdentity,
  InvalidSchoolCode,
  Success,
  Failure,
}

export enum ExamResultsFileBackendErrorCode {
  NonClosedAssessmentSessions = 1,
  NoExaminee,
  NoSchool,
}

export enum ExamRepositoryModalType {
  results,
  documentation,
  examineeDocumentation,
}

export enum SessionCopyBackendCode {
  Success,
  ExamSessionNotFound,
  ExamSessionIncorrectSourceSystem,
  ExamSessionNameDuplicated,
  ExamCodeDuplicated,
  ExamSheetNotFound,
  AnotherCopyInProgress,
}
